import { MobileRoute, useNavigationStore } from "presentation/mobile/stores/navigation-store";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface SubMenuProps {
    routes: MobileRoute[];
    categoryLabel: string;
}

const SubMenu = ({ routes, categoryLabel }: SubMenuProps) => {
    const navigate = useNavigate();
    const [clickedButtonRoute, setClickedButtonRoute] = useState("");
    const navigationStore = useNavigationStore();

    const navigateToRoute = (route: string) => {
        navigationStore.setPreviousRoute(navigationStore.currentRoute);
        navigate(route);
    };

    useEffect(() => {
        if (routes.length === 1) {
            navigateToRoute(routes[0].route);
        }
    }, [routes]);

    const sendBackToHome = () => {
        navigationStore.setUseSubMenu(false);
        navigationStore.setCurrentSubRoutes([]);
    };

    if (routes.length === 0) {
        return (
            <div className="h-screen flex flex-column align-items-center justify-content-center pt-6 gap-2">
                <i className="pi pi-exclamation-triangle text-4xl" style={{ color: "#CBD5E1" }} />
                <span className="text-sm text-center" style={{ color: "#64748B" }}>
                    Não tem acesso a nenhuma rota.
                </span>
            </div>
        );
    }

    if (routes.length === 1) {
        return null;
    }

    const visibleRoutes = routes.filter((item) => item.name !== "home");

    return (
        <div className="flex flex-column align-items-center w-full pb-8">
            {/* Barra de Navegação com Botão Voltar */}
            <div className="w-full px-3 pt-3 pb-1 flex align-items-center gap-2">
                <button
                    type="button"
                    className="border-none bg-transparent cursor-pointer p-0 flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px", color: "#0084D1" }}
                    onClick={sendBackToHome}
                    aria-label="Voltar"
                >
                    <i className="pi pi-arrow-left text-lg font-bold" />
                </button>
                <span className="text-xl font-bold text-900">{categoryLabel}</span>
            </div>

            {/* Grelha de Opções do SubMenu */}
            <div
                className="pt-3 px-3"
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "1rem",
                    width: "100%",
                }}
            >
                {visibleRoutes.map((item) => {
                    const isPressed = clickedButtonRoute === item.name;
                    return (
                        <div
                            key={item.route}
                            className="flex flex-column align-items-center justify-content-center cursor-pointer border-round-xl p-4 gap-3 transition-all transition-duration-200"
                            style={{
                                width: "100%",
                                backgroundColor: isPressed ? "#EBF3FC" : "#FFFFFF",
                                border: isPressed ? "1.5px solid #0084D1" : "1px solid #E2E8F0",
                                boxShadow: isPressed
                                    ? "0 4px 14px rgba(0, 132, 209, 0.1)"
                                    : "0 1px 3px rgba(0, 0, 0, 0.04)",
                                transform: isPressed ? "scale(0.98)" : "scale(1)",
                            }}
                            onClick={() => navigateToRoute(item.route)}
                            onPointerDown={() => setClickedButtonRoute(item.name)}
                            onPointerUp={() => setClickedButtonRoute("")}
                            role="button"
                        >
                            {/* Contentor de Ícone Squircle */}
                            <div
                                className="flex align-items-center justify-content-center border-round-xl"
                                style={{
                                    width: "48px",
                                    height: "48px",
                                    backgroundColor: "#EFF6FF",
                                }}
                            >
                                <i
                                    style={{ color: "#0084D1", fontSize: "1.35rem" }}
                                    className={`${item.icon}`}
                                />
                            </div>

                            {/* Nome da Sub-rota */}
                            <span className="font-semibold text-sm text-center text-800 line-height-2">
                                {item.label}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SubMenu;